export const DEFAULT_TOASTER_TIMEOUT = 5000;
